import React from 'react';
import './Login.css';
import {USERS_API} from "../constants";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: ''
    };
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  handleLogin(event) {
    event.preventDefault();
    const {username, password} = this.state;
    if (username !== '' && password !== '') {
      fetch(`${USERS_API}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username,
          password
        })
      })
      .then((response) => response.json())
      .then(res => {
        if (res && res.status === 1) {
          if (res.token) {
            localStorage.setItem("token", res.token);
            this.props.onLogin(true);
          } else {
            alert("Failed to login")
          }
        } else {
          alert("Failed to login")
        }
      }).catch(err => {
        alert("Failed to login")
      })
    } else {
      alert('Invalid Username or Password')
    }
  }

  handleUsernameChange(event) {
    this.setState({
      username: event.target.value
    })
  }

  handlePasswordChange(event) {
    this.setState({
      password: event.target.value
    })
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12 pt-4" style={{display: 'flex', justifyContent: 'center'}}>
            <div className="card card-signin my-5" style={{width: 600, marginTop: 50}}>
              <div className="card-body">
                <h5 className="card-title text-center">Sign In</h5>
                <form className="form-signin" onSubmit={this.handleLogin}>
                  <div className="form-label-group">
                    <input type="text" id="inputEmail" className="form-control" placeholder="Username" required
                           autoFocus onChange={this.handleUsernameChange}/>
                      <label htmlFor="inputEmail">Username</label>
                  </div>

                  <div className="form-label-group">
                    <input type="password" id="inputPassword" className="form-control" placeholder="Password" required onChange={this.handlePasswordChange}/>
                      <label htmlFor="inputPassword">Password</label>
                  </div>
                  <button className="btn btn-lg btn-primary btn-block text-uppercase" type="submit">Sign in</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login.js